import { AbortError } from '@app/errors/AbortError'

import { TimeMeasurer } from '@app/utils/TimeMeasurer'

import { createThunk } from '@app/store/thunk'

export const setFetch = (fetch: typeof global.fetch) =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().set(FETCH_SYMBOL, loggedFetch(fetch))
  })

export const getFetch = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().getEnsure<typeof global.fetch>(FETCH_SYMBOL)
  })

const FETCH_SYMBOL = Symbol('Api_Fetch')

const loggedFetch = (orfetch: typeof fetch) => {
  const mfetch: typeof fetch = async (...args: Parameters<typeof fetch>) => {
    using stack = new DisposableStack()
    const time = new TimeMeasurer()
    let status = 0
    stack.defer(() => {
      if (LOG_FETCH) logFetchPost(args, status, time)
    })
    try {
      const resp = await orfetch(...args)

      status = resp.status
      return resp
    } catch (e) {
      // create error that has same name and message across different browsers
      if (e instanceof Error && e.name === 'AbortError') {
        throw new AbortError()
      }
      throw e
    }
  }
  return mfetch
}

const logFetchPost = (args: Parameters<typeof fetch>, status: number, time: TimeMeasurer) => {
  const id = (args[1]?.headers as any)?.['X-Kidsout-App-Request-Id'] ?? ''
  const log = (status >= 400 ? console.error : console.info).bind(console)
  const url = (() => {
    try {
      if (typeof args[0] === 'string') return decodeURI(args[0]) || args[0]
      return args[0]
    } catch {
      return args[0]
    }
  })()
  log(`${id}`, '[fetch]', args[1]?.method ?? 'GET', url, status, time.diff())
}
